var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M7 20a1 1 0 1 1 0-2 1 1 0 0 1 0 2m16-2H9.815A2.995 2.995 0 0 0 7 16a2.995 2.995 0 0 0-2.815 2H1a1 1 0 1 0 0 2h3.185A2.995 2.995 0 0 0 7 22a2.995 2.995 0 0 0 2.815-2H23a1 1 0 1 0 0-2m-6-6a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m6-2h-3.185A2.993 2.993 0 0 0 17 8a2.993 2.993 0 0 0-2.815 2H1a1 1 0 1 0 0 2h13.185A2.995 2.995 0 0 0 17 14a2.995 2.995 0 0 0 2.815-2H23a1 1 0 1 0 0-2M7 2a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2M1 4h3.185A2.993 2.993 0 0 0 7 6a2.993 2.993 0 0 0 2.815-2H23a1 1 0 1 0 0-2H9.815A2.993 2.993 0 0 0 7 0a2.993 2.993 0 0 0-2.815 2H1a1 1 0 1 0 0 2"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#14BAD8",
    fillRule: "evenodd",
    transform: "translate(0 1)",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSettings);
export default __webpack_public_path__ + "static/media/blue-settings.c42f4c2b058856b8ea94cd9f972a6d3d.svg";
export { ForwardRef as ReactComponent };